import { render, staticRenderFns } from "./China.vue?vue&type=template&id=144c881d&scoped=true"
import script from "./China.vue?vue&type=script&lang=js"
export * from "./China.vue?vue&type=script&lang=js"
import style0 from "./China.vue?vue&type=style&index=0&id=144c881d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144c881d",
  null
  
)

export default component.exports